// import Component from './src/main.vue';
import Component from './src/card-page.vue';

Component.install = function install(_Vue) {
  _Vue.component(Component.name, Component);
};

export default Component;
